module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABQUlEQVR4AWOgDzDuRSDDfgaDfmbTblazLgajPgaDCQxGCFl0DUClArYtPqlJ1S0ejR2uScVhyl6VQCOAOlE0wFWLOjTWtLqvXarT1u3U2u28eL7hnJlmpmH5IA1GGBpYTHqSS0JXLdGNK4wIyowPyogPzY6bOtVq+nQLUYcmoHHoGiQdG6dPsyxt8KltdV8413jBHOOZM8x9UpPNQwrZzLqBlqBrUPOsWjTfOL08eN5s0xUL9ZctMNi6St0hNpNBYQ52P0g6Nc6YblFS71PX6r5orhHQktkzzb1Tkk2Di9hMwTZg+iG1NHTVYt3YgkigH4AoJCtu8hSrGbj8ABQSc2ysa3Nbs0S3pcsZiBbPM5o7y9Q8PA8zlBCxJmDX4peWCPR3c5dLcmmoijfOeEDoASIWs25W8y6gqeCY7kPIDkoAAJtYlS1mEYwsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/_commonwealth.png
// module id = 1311
// module chunks = 0